import request from '@/CommonDP/utils/request';
export default {
  addSysTag(params) {
    return request.post(`/sysTag/add`, params);
  },
  updateSysTag(params) {
    return request.post(`/sysTag/update`, params);
  },
  getSysTagList(enterpriseId) {
    return request.get(`/sysTag/list?enterpriseId=${enterpriseId}`);
  },
  deleteSysTag(tagId) {
    return request.get(`/sysTag/delete?tagId=` + tagId);
  },
  addSysTagRelation(params) {
    return request.post(`/sysTag/relation/add`, params);
  },
  deleteSysTagRelation(params) {
    return request.post(`/sysTag/relation/delete`, params);
  },
  getSysTagRelation(params) {
    return request.post(`/sysTag/relation/list`, params);
  },
  moveSysTag(moveType, tagId) {
    // moveType 1=上移，2=下移
    return request.post(`/sysTag/move?moveType=` + moveType + "&tagId=" + tagId);
  },
  getSysTagRelationNum(tagId) {
    return request.get(`/sysTag/relation/query?tagId=` + tagId);
  }
};
